import { ME_USERS_ALLOWED_PATHS } from "utils/country_utils"

export const isIeltsFlow = (pathName: string) =>
  ME_USERS_ALLOWED_PATHS.includes(pathName)
